export var MissingMemberHandling;
(function (MissingMemberHandling) {
    MissingMemberHandling[MissingMemberHandling["Ignore"] = 0] = "Ignore";
    MissingMemberHandling[MissingMemberHandling["Error"] = 1] = "Error"; // Not supported yet
})(MissingMemberHandling || (MissingMemberHandling = {}));
